<template>

  <div class="page">

    <page-header-hero :video="page.header_video"></page-header-hero>

    <main class="page-content container">
      <div id="page-anchor" class="icon-angle-down pb-2"></div>
      <div class="row justify-content-center pb-3">
        <h2 class="col-12 text-center headlined">Artists</h2>
        <div class="col-sm-6 col-md-4 artist-tile" v-for="artist in this.shuffledArtists" v-if="loaded">
          <router-link :to="'/artist/'+(artist.artist_name).replace(/\s+/g, '-').toLowerCase()" class="artist-tile__link">
            <noscript is="lazy-element" class="lazy-element ratio-square">
              <img :alt="artist.artist_name" :src="artist.artist_thumb" class="artist-tile__image">
            </noscript>
            <span class="artist-tile__name">{{artist.artist_name}}</span>
          </router-link>
        </div>
      </div>
      
      <div class="row pb-4" v-if="this.cookies">
        <h2 class="col-12 text-center headlined">Dates</h2>
        <div class="col-12 text-center">
          <div class="fb-page" :data-href="this.page.goodhood_facebook_events" data-tabs="events" data-width="500" data-height="400" data-small-header="true" data-adapt-container-width="true" data-hide-cover="true" data-show-facepile="false"></div>
        </div>
      </div>
      
      <div class="row pb-4">
        <h2 class="col-12 text-center headlined">Booking</h2>
        <div class="col-12 text-center">
          {{page.booking_text}} <span class="mail"><span>{{reversedEmail}}</span></span>
        </div>
      </div>

    </main>

    <page-footer :social-media="page.social_media"></page-footer>

    <div class="popup" :class="{ 'popup--open': showArtist }">
      <div class="popup__overlay" @click="closePopup()">
        <img class="popup__logo" alt="GoodHoodMusic" src="../assets/img/good-hood-music.svg">
        <div class="icon-close"></div>
      </div>
      <transition name="slide-up">
        <router-view v-if="loaded" @close="$router.back()" v-bind:page="page"></router-view>
      </transition>
    </div>

    <cookie-banner v-if="this.cookieBanner" @banner="showCookieBanner" @cookies="setCookie"></cookie-banner>

  </div>

</template>

<script>
  import LazyElement from '../components/LazyElement.vue';
  import PageHeaderHero from '../components/PageHeaderHero.vue';
  import PageFooter from '../components/PageFooter.vue';
  import CookieBanner from "../components/CookieBanner";

  export default {
    name: 'Home',
    components: {
      CookieBanner,
      LazyElement,
      PageHeaderHero,
      PageFooter
    },
    watch: {
      $route(a) {
        this.showArtist = a.meta && a.meta.showArtist;
      }
    },
    data: function () {
      return {
        showArtist: this.$route.matched.some(record => record.meta.showArtist),
        page: [],
        shuffledArtists: [],
        loaded: false,
        cookieBanner: true,
        cookies: false
      }
    },
    computed: {
      reversedEmail(){
        if (this.page.booking_email)
          return this.page.booking_email.split('').reverse().join('')
      }
    },
    methods: {
      init: function() {
        if (this.$route.matched.some(record => record.meta.showArtist)) {
          this.showArtist = true;
        }
      },
      closePopup: function() {
        this.showArtist = false;
        this.$router.push('/');
        setTimeout(function() {
          document.querySelector('#page-anchor').scrollIntoView({behavior: 'smooth'});
        },100);
      },
      setCookie: function(v) {
        this.cookies = v;
        setTimeout(function(){FB.XFBML.parse()},1000);
      },
      showCookieBanner: function(v) {
        this.cookieBanner = v;
      },
      shuffle: function(array) {
        for (let i = array.length - 1; i > 0; i--) {
          let j = Math.floor(Math.random() * (i + 1));
          [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
      }

  },
    mounted() {
      this.axios
        .get('https://goodhoodmusic.com/wp-json/wp/v2/pages?acf_format=standard')
        .then((response) => {
          for (const value of response.data) {
            if (value.id === 2) {
              this.page = value.acf;
              this.shuffledArtists = this.shuffle(this.page.artists);
              this.loaded = true;
            }
          }
        });
      this.init();
    }
  }
</script>
